export var space = [0, 4, 8, 12, 16, 24, 32, 40, 48];
